<template>
  <div class="flex flex-col justify-center items-center px-4">
    <img src="@/assets/sola.png" alt="Šola" style="max-height:20vh">
    <h1 class="text-center uppercase bold mt-8 mb-2">Šola</h1>
    <p class="text-center font-light">Možnost druženja v varnem okolju ob podpori učiteljev, prostor za pridobivanje novih znanj, raziskovanj ter izkušenj</p>
  </div>
</template>